<div class="_devices-desktop-page">

	<segment-desktop-component [segments]="segments" [selectedSegment]="selectedSegment"
		(selectedSegmentChange)="onSelectedSegmentChange($any($event))"></segment-desktop-component>

	<ng-template #bulkActions>
		<ng-container *ifUserHasPermissions="[UserPermissions.WriteDevices]">
			<div class="_bulk-actions">
				<button [disabled]="!(this.selectedDevices.length > 0)" class="_button _filter-button" (click)="toggleBulkActions()">
					<ion-icon src="./assets/icons/wrench-and-screwdriver-outline.svg"></ion-icon>
				</button>
				<div class="_bulk-actions-dropdown" *ngIf="showBulkActions">
					<p *ngIf="selectedSegment !== getSegmentName(this.segments[1])" (click)="updateDevicesStatus(DeviceStatus.InStock)">
						{{'DEVICE.CHANGE_STATUS.IN_STOCK' | translate}}
					</p>
					<p *ngIf="selectedSegment !== getSegmentName(this.segments[4])" (click)="updateDevicesStatus(DeviceStatus.InRefurbish)">
						{{'DEVICE.CHANGE_STATUS.IN_REFURBISHED' | translate}}
					</p>
					<p *ngIf="selectedSegment !== getSegmentName(this.segments[3])" (click)="updateDevicesStatus(DeviceStatus.Returned)">
						{{'DEVICE.CHANGE_STATUS.RETURNED' | translate}}
					</p>
					<p *ngIf="selectedSegment !== getSegmentName(this.segments[5])" (click)="updateDevicesStatus(DeviceStatus.Disabled)">
						{{'DEVICE.CHANGE_STATUS.DISABLED' | translate}}
					</p>
					<p class="_delete" *ngIf="selectedSegment === getSegmentName(this.segments[5])" (click)="deleteDevices()">
						{{'DEVICE.DELETE_BATCH' | translate}}
					</p>
				</div>
			</div>
		</ng-container>
	</ng-template>

	<ng-template #buttons>
		<div class="_header_buttons_wrapper">
			<ng-container *ifUserHasPermissions="[UserPermissions.WriteLoans]">
				<button [disabled]="selectedSegment !== getSegmentName(this.segments[1]) && this.selectedDevices.length > 0" type="button" button class="_button _loan-button" (click)="loanDevice()">
					<ion-icon src="./assets/icons/up-outline.svg"></ion-icon>
					<span>{{ 'DEVICE.LOAN' | translate}}</span>
				</button>
				<button [disabled]="this.selectedDevices.length > 0" type="button" button class="_button _return-button" (click)="endLoan()">
					<ion-icon src="./assets/icons/down-outline.svg"></ion-icon>
					<span>{{ 'LOAN.END' | translate}}</span>
				</button>
			</ng-container>
			<ng-container *ifUserHasPermissions="[UserPermissions.WriteDevices]" button>
				<button [disabled]="this.selectedDevices.length > 0" type="button" button class="_button _add-button _inverse" (click)="openDevice()">
					<ion-icon src="./assets/icons/add-outline.svg"></ion-icon>
					<span>{{ 'DEVICE.CREATE' | translate}}</span>
				</button>
				<button [disabled]="this.selectedDevices.length > 0" type="button" button class="_button _upload-button _inverse" (click)="uploadDevices()">
					<ion-icon src="./assets/icons/upload-outline.svg"></ion-icon>
					<span>{{ 'DEVICES_IMPORT.IMPORT' | translate}}</span>
				</button>
			</ng-container>
		</div>
	</ng-template>

	<ng-container [ngSwitch]="selectedSegment">

		<!-- ALL -->
		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[0])">
			<table-desktop-component [headers]="tableHeaders[0]" [filters]="tableFilters"
				[dataRequest]="allDevicesDataRequest" (dataChanged)="dataChanged($any($event))" stateKey="all-devices" class="_wrap">
				
				<ng-container *ngTemplateOutlet="buttons" button></ng-container>

				<ion-row 
					data 
					class="_row _data ion-align-items-center" 
					*ngFor="let device of allDevices"
					[ngClass]="{
						'_in-stock': device.status === DeviceStatus.InStock, 
						'_in-loan': device.status === DeviceStatus.InLoan,
						'_returned': device.status === DeviceStatus.Returned,  
						'_in-refurbished': device.status === DeviceStatus.InRefurbish,
						'_disabled': device.status === DeviceStatus.Disabled
					}">

					<table-col [size]="3">
						<b>{{device.DeviceType.name}} (<i>{{ 'DEVICE_STATUS.' + device.status | uppercase |
								translate}}</i>)</b><br>
						<ng-container *ngIf="device.description">{{device.description}}<br></ng-container>
						<i>{{device.serial}}</i>
					</table-col>

					<table-col [size]="3">{{device.note}}</table-col>

					<table-col class="_center" [size]="3">
						<button
							*ifUserHasPermissions="[UserPermissions.WriteLoans]"
							[disabled]="!(device.status === DeviceStatus.InStock && device.isActive)"
							type="button" class="_button _loan-button" (click)="loanDevice(device)"
						>
							<ion-icon src="./assets/icons/up-outline.svg"></ion-icon>
							<span>{{ 'DEVICE.LOAN_DEVICE' | translate}}</span>
						</button>
					</table-col>

					<table-col class="_center" [size]="3">
						<button 
							[disabled]="device.status !== DeviceStatus.InLoan" 
							type="button" 
							*ifUserHasPermissions="[UserPermissions.WriteLoans]"
							class="_button _return-button" 
							(click)="endLoan(device.Loans[0])"
						>
							<ion-icon src="./assets/icons/down-outline.svg"></ion-icon>
							<span>{{ 'LOAN.END' | translate}}</span>
						</button>
					</table-col>

					<table-col class="_center" [size]="3">
						<ng-container *ifUserHasPermissions="[UserPermissions.WriteDevices]">
							<button type="button" class="_button _info-button" (click)="openDevice(device)"
								title="{{ 'DEVICE.EDIT' | translate}}">
								<ion-icon src="./assets/icons/info-outline.svg"></ion-icon>
								<span>{{ 'DEVICE.OPEN' | translate}}</span>
							</button>
						</ng-container>
					</table-col>
				</ion-row>
			</table-desktop-component>
		</div>

		<!-- IN STOCK -->
		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[1])">

			<table-desktop-component [headers]="tableHeaders[1]" [filters]="tableFilters"
				[dataRequest]="inStockDataRequest" (dataChanged)="dataChanged($any($event))"
				stateKey="in-stock-devices" class="_wrap">

				<ng-container *ngTemplateOutlet="bulkActions" button></ng-container>
				<ng-container *ngTemplateOutlet="buttons" button></ng-container>

				<ion-row data class="_row _data ion-align-items-center _in-stock" *ngFor="let device of inStockDevices">
					<table-col class="_center" [size]="1">
						<ion-checkbox color="success" [value]="selectedDevices.includes(device)" (ionChange)="toggleSelection(device)"></ion-checkbox>
					</table-col>

					<table-col [size]="3">
						<b>{{device.DeviceType.name}} (<i>{{ 'DEVICE_STATUS.' + device.status | uppercase |
								translate}}</i>)</b><br>
						<ng-container *ngIf="device.description">{{device.description}}<br></ng-container>
						<i>{{device.serial}}</i>
					</table-col>

					<table-col [size]="5">{{device.note}}</table-col>

					<table-col class="_center" [size]="3">
						<button
							[disabled]="!(device.status === DeviceStatus.InStock && device.isActive)"
							*ifUserHasPermissions="[UserPermissions.WriteLoans]"
							type="button" class="_button _loan-button" (click)="loanDevice(device)"
						>
							<ion-icon src="./assets/icons/up-outline.svg"></ion-icon>
							<span>{{ 'DEVICE.LOAN_DEVICE' | translate}}</span>
						</button>
					</table-col>

					<table-col class="_center" [size]="3">
						<ng-container *ifUserHasPermissions="[UserPermissions.WriteDevices]">
							<button type="button" class="_button _info-button" (click)="openDevice(device)"
								title="{{ 'DEVICE.EDIT' | translate}}">
								<ion-icon src="./assets/icons/info-outline.svg"></ion-icon>
								<span>{{ 'DEVICE.OPEN' | translate}}</span>
							</button>
						</ng-container>
					</table-col>
				</ion-row>
			</table-desktop-component>
		</div>


		<!-- IN LOAN -->
		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[2])">
			<table-desktop-component [headers]="tableHeaders[2]" [filters]="loanTableFilters" [dataRequest]="inLoanDataRequest"
				(dataChanged)="dataChanged($any($event))" stateKey="in-loan-devices" class="_wrap">

				<ng-container *ngTemplateOutlet="buttons" button></ng-container>

				<ion-row data class="_row _data ion-align-items-center _in-loan" *ngFor="let loan of loans" [ngClass]="{'_not-active': loan.isActive === false}">

					<table-col [size]="3">
						<ng-container *ngIf="loan.Client">
							<b>{{'LOAN.LOANED_TO_CLIENT' | translate}}:</b><br>
							{{loan.Client.firstname}} {{loan.Client.lastname}}<br>
							{{loan.Client.Address | address}}
						</ng-container>
						<ng-container *ngIf="loan.DigibankAgencyOnLoan">
							<b>{{'LOAN.LOANED_TO_PARTNER' | translate}}:</b><br>
							{{loan.DigibankAgencyOnLoan.DigibankAgency.name}}<br>
							{{loan.DigibankAgencyOnLoan.contactName}} - {{loan.DigibankAgencyOnLoan.contactEmail}}
						</ng-container>
					</table-col>

					<table-col [size]="2" class="_number-of-devices">
						@if (loan.hasNoDigiportalDevice) {
							<span>{{'LOAN.START_WITHOUT_DEVICE' | translate}}</span>
						} @else {
							<span>{{loan.numberOfDevices}}</span>

							<ng-template #devices>
								<div style="padding: 10px;" *ngFor="let device of loan.Devices">
									{{device.DeviceType.name}} ({{device.serial}})<br>
								</div>
							</ng-template>
						}

					</table-col>

					<table-col [size]="2">
						<p>{{loan.startsAt | date:"d / MM / yy"}}</p>
					</table-col>

					<table-col [size]="2">
						<p>{{loan.endsAt | date:"d / MM / yy"}}</p>
					</table-col>

					<table-col class="_center" [size]="3">
						<button *ifUserHasPermissions="[UserPermissions.WriteLoans]" type="button" class="_button _return-button" (click)="endLoan(loan)">
							<ion-icon src="./assets/icons/down-outline.svg"></ion-icon>
							<span>{{ 'LOAN.END' | translate}}</span>
						</button>

					</table-col>

					<table-col class="_center" [size]="3">

						<button *ifUserHasPermissions="[UserPermissions.ReadLoans]" type="button" class="_button _info-button" (click)="editLoan(loan)">
							<ng-container *ifUserHasPermissions="[UserPermissions.WriteLoans]">
								<ion-icon src="./assets/icons/edit-outline.svg"></ion-icon>
								<span>{{ 'LOAN.EDIT' | translate}}</span>
							</ng-container>
							<ng-container *ifUserHasNotPermissions="[UserPermissions.WriteLoans]">
								<ion-icon src="./assets/icons/info-outline.svg"></ion-icon>
								<span>{{ 'LOAN.INFO' | translate}}</span>
							</ng-container>
						</button>

					</table-col>
				</ion-row>
			</table-desktop-component>
		</div>

		<!-- IN RETURNED -->
		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[3])">
			<table-desktop-component [headers]="tableHeaders[4]" [filters]="tableFilters"
				[dataRequest]="returnedDataRequest" (dataChanged)="dataChanged($any($event))"
				stateKey="inactive-devices" class="_wrap">

				<ng-container *ngTemplateOutlet="bulkActions" button></ng-container>
				<ng-container *ngTemplateOutlet="buttons" button></ng-container>

				<ion-row data class="_row _data ion-align-items-center _returned"
					*ngFor="let device of returnedDevices">

					<table-col class="_center" [size]="1">
						<ion-checkbox color="success" [value]="selectedDevices.includes(device)" (ionChange)="toggleSelection(device)"></ion-checkbox>
					</table-col>

					<table-col [size]="3">
						<b>{{device.DeviceType.name}} (<i>{{ 'DEVICE_STATUS.' + device.status | uppercase |
								translate}}</i>)</b><br>
						<ng-container *ngIf="device.description">{{device.description}}<br></ng-container>
						<i>{{device.serial}}</i>
					</table-col>

					<table-col [size]="8">{{device.note}}</table-col>

					<table-col class="_center" [size]="3">
						<ng-container *ifUserHasPermissions="[UserPermissions.WriteDevices]">
							<button type="button" class="_button _info-button" (click)="openDevice(device)"
								title="{{ 'DEVICE.EDIT' | translate}}">
								<ion-icon src="./assets/icons/info-outline.svg"></ion-icon>
								<span>{{ 'DEVICE.OPEN' | translate}}</span>
							</button>
						</ng-container>
					</table-col>
				</ion-row>
			</table-desktop-component>
		</div>

		<!-- IN REFURBISHED -->
		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[4])">
			<table-desktop-component [headers]="tableHeaders[3]" [filters]="tableFilters"
				[dataRequest]="inRefurbishDataRequest" (dataChanged)="dataChanged($any($event))"
				stateKey="in-refurbish-devices" class="_wrap">

				<ng-container *ngTemplateOutlet="bulkActions" button></ng-container>
				<ng-container *ngTemplateOutlet="buttons" button></ng-container>

				<ion-row data class="_row _data ion-align-items-center _in-refurbished"
					*ngFor="let device of inRefurbishDevices">

					<table-col class="_center" [size]="1">
						<ion-checkbox color="success" [value]="selectedDevices.includes(device)" (ionChange)="toggleSelection(device)"></ion-checkbox>
					</table-col>

					<table-col [size]="3">
						<b>{{device.DeviceType.name}} (<i>{{ 'DEVICE_STATUS.' + device.status | uppercase |
								translate}}</i>)</b><br>
						<ng-container *ngIf="device.description">{{device.description}}<br></ng-container>
						<i>{{device.serial}}</i>
					</table-col>

					<table-col [size]="8">{{device.note}}</table-col>

					<table-col class="_center" [size]="3">
						<ng-container *ifUserHasPermissions="[UserPermissions.WriteDevices]">
							<button type="button" class="_button _info-button" (click)="openDevice(device)"
								title="{{ 'DEVICE.EDIT' | translate}}">
								<ion-icon src="./assets/icons/info-outline.svg"></ion-icon>
								<span>{{ 'DEVICE.OPEN' | translate}}</span>
							</button>
						</ng-container>
					</table-col>
				</ion-row>
			</table-desktop-component>
		</div>

		<!-- DISABLED -->
		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[5])">
			<table-desktop-component [headers]="tableHeaders[4]" [filters]="tableFilters"
				[dataRequest]="disabledDataRequest" (dataChanged)="dataChanged($any($event))"
				stateKey="inactive-devices" class="_wrap">

				<ng-container *ngTemplateOutlet="bulkActions" button></ng-container>
				<ng-container *ngTemplateOutlet="buttons" button></ng-container>

				<ion-row data class="_row _data ion-align-items-center _disabled"
					*ngFor="let device of disabledDevices">

					<table-col class="_center" [size]="1">
						<ion-checkbox color="success" [value]="selectedDevices.includes(device)" (ionChange)="toggleSelection(device)"></ion-checkbox>
					</table-col>

					<table-col [size]="3">
						<b>{{device.DeviceType.name}} (<i>{{ 'DEVICE_STATUS.' + device.status | uppercase |
								translate}}</i>)</b><br>
						{{device.description}}<br>
						<i>{{device.serial}}</i><br>
					</table-col>

					<table-col [size]="8">{{device.note}}</table-col>

					<table-col class="_center" [size]="3">
						<ng-container *ifUserHasPermissions="[UserPermissions.WriteDevices]">
							<button type="button" class="_button _info-button" (click)="openDevice(device)"
								title="{{ 'DEVICE.EDIT' | translate}}">
								<ion-icon src="./assets/icons/info-outline.svg"></ion-icon>
								<span>{{ 'DEVICE.OPEN' | translate}}</span>
							</button>
						</ng-container>
					</table-col>
				</ion-row>

			</table-desktop-component>
		</div>
	</ng-container>
</div>